module.exports = __webpack_public_path__ + "static/media/rcs-vale.078ab1f1.png";